import { atom } from 'jotai';
import { selectAtom } from 'jotai/utils';

/**
 * URL params atom.
 */
export const urlParamsAtom = atom<
    Partial<{
        activityId?: string;
        swingId?: string;
        layoutId?: string;
    }>
>();

export const activityIdAtom = selectAtom(urlParamsAtom, (params) => {
    if (typeof params?.activityId === 'undefined') return -1;
    const convertedParam = Number(params?.activityId);
    return Number.isNaN(convertedParam) ? -1 : convertedParam;
});

export const activeSwingIdAtom = selectAtom(urlParamsAtom, (params) => params?.swingId);
